module.exports = __webpack_public_path__ + "static/img/model_one.a913e30.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/model_one.png
// module id = 4eTt
// module chunks = 0